import { gql } from '@apollo/client';

export const GET_VERTEX_AI_RECIPES = gql`
  query GetVertexAIRecipes(
    $excludedIngredients: [String!]
    $recipeNumber: Int!
    $query: String!
    $brandKey: BrandKey!
  ) {
    getVertexAIRecipes(
      excludedIngredients: $excludedIngredients
      recipeNumber: $recipeNumber
      query: $query
      brandKey: $brandKey
    ) {
      recipesIds
      ingredients {
        name
        count
      }
    }
  }
`;
